import React from "react";
import { Navigate } from "react-router-dom";
import { useLocalStorage } from '../../utils/storage';

const AuthRedirect = ({ children }) => {
    const [token] = useLocalStorage('token');

    if (token && token != null) {
        return <Navigate to="/notches" />;
    }

    return children;
};

export default AuthRedirect;
